export enum HTTP_METHODS {
  GET = 'GET',
  POST = 'POST',
  DELETE = 'DELETE',
  PUT = 'PUT',
  PATCH = 'PATCH',
}

export enum DELIVERY_METHODS {
  PICKUP = 'pickup',
  DELIVERY = 'delivery',
}
